import { useRef, useState, createContext, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import  MapLidar from "./component/MapLidar";
import MapLidarDerivee from "./component/MapLidarDerivee";
import "../node_modules/geoportal-extensions-openlayers/dist/GpPluginOpenLayers.css";
import "../node_modules/ol/ol.css";
import Footer from "./component/Footer";
import Header from "./component/Header";

export const appContext = createContext();

export default function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<MapLidar/>}/>
            <Route path="/mnx" element={<MapLidarDerivee/>}/>
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}
